import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, Statistic, Progress } from "antd";
import moment from "moment";

import { secons2text } from "../../services/timeFunctions";

//import { useDispatch } from "react-redux";

import { marksAgitation } from "../../constants";

// Styles
import { Wrapper, H3 } from "./styles";

import Table from "../../components/table";
import Search from "../../components/table/search";

import Colors from "../../theme/colors";

// Hooks
import useManufacturingOrder from "../../hooks/useManufacturingOrder";
import useInterval from "../../hooks/useInterval";

//import multilanguage library
import { useTranslation } from "react-i18next";

const temperaturePrograming = 950;

const RenderFurnace = ({ quenchingStatus }) => {
  const [manufacturingList, setManufacturingList] = useState(null);
  const [availableArticle, setAvailableArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);

  const [count2Furnace, setCount2Furnace] = useState(0);

  const [furnaceNowTemperature, setFurnaceNowTemperature] = useState(950);

  const { manufacturingOrder, updateData } = useManufacturingOrder();

  //To translate text
  const { t } = useTranslation();

  useInterval(() => {
    if (furnaceNowTemperature < temperaturePrograming) {
      setFurnaceNowTemperature((prevState) => prevState + 10);
      //para mantener el efecto
      localStorage.setItem("furnaceTemp", furnaceNowTemperature);
    }
  }, 1000);

  //To refresh time to out furnace
  useInterval(() => {
    //set same value
    setFurnaceArticle([...furnaceArticle]);
  }, 30000);

  useEffect(() => {
    let temp = localStorage.getItem("furnaceTemp");
    if (temp) setFurnaceNowTemperature(parseInt(temp));
  }, []);

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order,
      };
    });
    let n2Furnace = 0;
    const availableList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        if (!piece.furnace) n2Furnace++;
        let a = {
          key: x + "-" + piece.id,
          ...piece,
          name: order.name,
          furnace: {
            time: order.desing.recommendation.furnace_time,
            temperature: order.desing.furnace.temperature,
            ...piece.furnace,
          },
          quenching: {
            bath_type: order.desing.quenching.bath_type,
            bath_temperature: order.desing.quenching.bath_temperature,
            agitation_level: order.desing.quenching.agitation_level,
          },
        };
        if (!piece.furnace) availableList.push(a);
        if (piece.furnace && piece.furnace.start && !piece.furnace.end) intoFurnaceList.push(a);
      });
    });

    setCount2Furnace(n2Furnace);

    setAvailableArticle(availableList);
    setFurnaceArticle(intoFurnaceList);

    normalized && setManufacturingList(normalized);
  }, [manufacturingOrder]);

  const columnsOrders = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.article"),
      dataIndex: "article.name",
      key: "article.name",
    },
    {
      title: t("table.header.percent_pieces_furnace"),
      dataIndex: "pieces",
      key: "pieces",
      render: (text, record) => {
        if (!record.pieces) return;
        //Furnace end in each piece
        let ended = record.pieces.reduce((total, x) => (x.furnace && x.furnace.end ? total + 1 : total), 0);
        let percent = parseInt((100 * ended) / record.pieces.length);

        return (
          <div style={{ width: "100%" }}>
            <Progress percent={percent} size="small" />
          </div>
        );
      },
    },
  ];

  const columnsAvailable = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.furnace_temp"),
      dataIndex: "furnace.temperature",
      key: "furnace.temperature",
    },
    {
      title: t("table.header.quenching_temp"),
      dataIndex: "quenching.bath_temperature",
      key: "quenching.bath_temperature",
    },
    {
      title: t("table.header.action"),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        return (
          <div
            style={
              {
                /*width: 170*/
              }
            }
          >
            <Button
              type="link"
              size="small"
              disabled={
                !(record.furnace.temperature > furnaceNowTemperature - 10 && record.furnace.temperature < furnaceNowTemperature + 10)
              }
              onClick={() => article2furnace(record.id, record.name)}
            >
              {t("button.action.to_furnace")}
              <Icon type="right" />
            </Button>
          </div>
        );
      },
    },
  ];

  const columnsFurnace = [
    {
      title: t("table.header.ref"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.entry_date"),
      dataIndex: "furnace.start",
      key: "furnace.start",
      render: (value) => value.format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.exit_date"),
      dataIndex: "furnace.time",
      key: "furnace.time",
      render: (time, record) => {
        let start = record.furnace.start;
        let sec = start.unix();
        return moment((sec + time) * 1000).format("DD/MM/YYYY HH:mm:ss");
        //time.format("HH:mm:ss");
      },
    },
    {
      title: t("table.header.remaining_time"),
      dataIndex: "furnace.time",
      key: "furnace.temperature",
      render: (time, record) => {
        let start_sec = record.furnace.start.unix();
        let end_sec = start_sec + time;

        let plusTime = record.furnace.plusTime ? record.furnace.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo
        //this_sec += 7000 //Prueba de color
        let difference = end_sec - this_sec;
        let negative = difference < 0;

        return negative ? <h3 style={{ color: "red" }}>{"- " + secons2text(-1 * difference)}</h3> : <h3>{secons2text(difference)}</h3>;

        //return <h3>{secons2Dhm(end_sec-this_sec)}</h3>
        //time.format("HH:mm:ss");
      },
    },
    {
      title: t("table.header.action"),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        let start_sec = record.furnace.start.unix();
        let end_sec = start_sec + record.furnace.time;

        let plusTime = record.furnace.plusTime ? record.furnace.plusTime : 0;
        let this_sec = moment().unix() + plusTime; //This is for demo
        let difference = end_sec - this_sec;
        let disabled = difference > 0;

        return (
          <div
            style={
              {
                /*width: 170*/
              }
            }
          >
            <Button type="link" size="small" disabled={disabled} onClick={() => article2out(record.id, record.name)}>
              {t("button.action.take")}
              <Icon type="right" />
            </Button>
          </div>
        );
      },
    },
  ];

  const article2furnace = (id, name) => {
    let order = manufacturingOrder.find((obj) => obj.name === name);
    let list = order.pieces.map((obj) => {
      if (obj.id === id) {
        return {
          ...obj,
          furnace: {
            start: moment(),
          },
        };
      } else return obj;
    });
    order.pieces = list;
    order.making = true;
    updateData(order);
  };

  const article2out = (id, name) => {
    let order = manufacturingOrder.find((obj) => obj.name === name);
    let list = order.pieces.map((obj) => {
      if (obj.id === id) {
        return {
          ...obj,
          furnace: {
            ...obj.furnace,
            end: moment(),
          },
          quenching: {
            start: moment(),
          },
        };
      } else return obj;
    });
    order.pieces = list;
    updateData(order);
  };

  //const timeRun = () => setPlusTime(prevTime => prevTime+600)
  const timeRunFurnace = (seconds) => {
    manufacturingOrder.forEach((order) => {
      if (order.making) {
        let list = order.pieces.map((obj) => {
          if (obj.furnace && obj.furnace.start && !obj.furnace.end) {
            let plusTime = obj.furnace.plusTime ? obj.furnace.plusTime : 0;

            return {
              ...obj,
              furnace: {
                ...obj.furnace,
                plusTime: plusTime + seconds,
              },
            };
          } else return obj;
        });
        order.pieces = list;
        updateData(order);
      }
    });
  };

  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={8} lg={10} md={24}>
          <H3>{t("headers.control_process.available_pieces", { value: count2Furnace })}</H3>
          <Table data={availableArticle} columns={columnsAvailable} size="small" pagination={{ pageSize: 15 }} />
        </Col>
        <Col xl={2} lg={4} md={24}>
          <H3>{t("headers.control_process.status")}</H3>
          <Col span={24}>
            <Statistic
              title={t("labels.state.furnace_temp")}
              value={furnaceNowTemperature}
              precision={2}
              valueStyle={{ color: furnaceNowTemperature !== temperaturePrograming ? Colors.primary : Colors.success }}
              prefix={furnaceNowTemperature !== temperaturePrograming && <Icon type="arrow-up" />}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.programed_temp")}
              value={temperaturePrograming}
              precision={2}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.quenching_temp")}
              value={quenchingStatus && quenchingStatus.bath_temperature}
              precision={2}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.quenching_type")}
              value={quenchingStatus && t("labels.quenching.bath_type." + quenchingStatus.bath_type)}
              style={{ textAlign: "center" }}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.state.agitation_level")}
              value={quenchingStatus && quenchingStatus.agitation_level && marksAgitation[quenchingStatus.agitation_level]}
              precision={2}
              suffix="m/s"
              style={{ textAlign: "center" }}
            />
          </Col>
        </Col>
        <Col xl={14} lg={10} md={24} style={{ height: "calc(60vh - 210px)" }}>
          <Row>
            <Col span={8}></Col>
            <Col span={8}>
              <H3>{t("headers.control_process.pieces_in_furnace", { value: furnaceArticle && furnaceArticle.length })}</H3>
            </Col>
            <Col span={8}>
              <Button type="link" size="small" style={{ float: "right" }} onClick={() => timeRunFurnace(600)}>
                <Icon type="clock-circle" />
                {t("button.advance_time", { time: 10 })}
              </Button>
            </Col>
          </Row>
          <Table data={furnaceArticle} columns={columnsFurnace} pagination={{ pageSize: 5 }} size="small" />
        </Col>
        <Col xl={14} lg={24} md={24}>
          <H3>{t("headers.control_process.manufacturing_order")}</H3>
          <Table data={manufacturingList} columns={columnsOrders} pagination={{ pageSize: 4 }} size="small" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default RenderFurnace;
